import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { SlModal } from '../SlModal/SlModal';

import s from './SlConfirmationModal.scss';

export interface ISlConfirmationModalProps {
	modalId: string;
	title: string;
	info?: string;
	Info?: JSX.Element;
	closeBtnCallback?: () => void;
	cssClass?: string;
	actions: {
		name: string;
		handler: (e: React.MouseEvent) => void;
		btnType?: 'secondary' | 'primary' | 'danger';
		style?: {
			[key: string]: string;
		};
		disabled?: boolean;
	}[];
}

export const SlConfirmationModal: React.FC<ISlConfirmationModalProps> = React.memo(
	({
		modalId,
		title,
		info,
		Info,
		actions,
		closeBtnCallback,
		cssClass,
	}) => {
		useStyles(s);
		return (
			<SlModal
				id={modalId}
				closeBtnCallback={closeBtnCallback}
				cssClass={cssClass}
			>
				<div className="sl-confirm-action">
					<h4 className="sl-confirm-action__title">{title}</h4>
					{info ? (
						<p className="sl-confirm-action__question">
							{info}
						</p>
					) : null}
					{Info}
					{
						!!actions?.length && (
							<div className="sl-confirm-action__footer">
								{actions.map((action) => (
									<button
										className={`sl-confirm-action__button sl-confirm-action__button--${
											action.btnType || 'danger'
										}`}
										style={action.style}
										onClick={action.handler}
										key={action.name}
										type="button"
										disabled={action.disabled}
									>
										{action.name}
									</button>
								))}
							</div>
						)
					}
				</div>
			</SlModal>
		);
	},
);
